import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

/**
 * Handles Emergent Google OAuth redirect: URL #session_id=...
 * Exchanges session_id with backend (which sets the session cookie) then routes user.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");
  const processedRef = React.useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;
    const hash = loc.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: m[1] });
        if (r.data.session_token) {
          const { setToken } = await import("../lib/api");
          setToken(r.data.session_token);
        }
        await refresh();
        if (r.data.attraction_id) nav("/dashboard/overview", { replace: true });
        else nav("/onboarding", { replace: true });
      } catch (e) {
        setErr("Could not complete Google sign-in. Please try again.");
      }
    })();
  }, [loc.hash, nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-center px-6">
      <div data-testid="auth-callback">
        <div className="text-[#dc2626] st-brand text-5xl mb-4">Welcome</div>
        <p className="text-[#8a8a8a]">{err || "Finishing sign-in…"}</p>
      </div>
    </div>
  );
}
